<template>
  <a
    :href="attachment.url"
    target="_blank"
    rel="noopener noreferrer"
    class="inline-flex items-center gap-1 text-sm text-primary hover:underline"
  >
    <PaperClipIcon class="h-4 w-4" />
    <span>{{ attachment.name || attachment.url }}</span>
  </a>
</template>

<script>
import { PaperClipIcon } from "@heroicons/vue/outline";

export default {
  name: "IntercomAttachmentLink",

  components: { PaperClipIcon },

  props: {
    attachment: {
      type: Object,
      required: true,
    },
  },
};
</script>
